require('../../modules/es6.function.has-instance');
module.exports = require('../../modules/_wks-ext').f('hasInstance');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/has-instance.js
// module id = 434
// module chunks = 4 6 7 8 9 10 12 21 22 24 26 27 29 55 56